<template>
  <vxe-layout-body>
    <vxe-card size="small" title="" width="100%">
      <template #title>
        <compact-form :data="query" :items="queryItems" :span="4" style="width: 80%" @submit="refresh">
          <template #right>
            <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="refresh"/>
            <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
          </template>
        </compact-form>
      </template>
      <template #extra>
        <compact-form style="width: 96%" @submit="send">
          <template #form>
            <vxe-form-item :span="24">
              <vxe-input v-model="query.wave" clearable placeholder="输入波次或多选明细"/>
            </vxe-form-item>
          </template>
          <template #right>
            <vxe-button content="button.sending" size="mini" status="primary" @click="send"/>
          </template>
        </compact-form>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :export-config="{}"
        :height="scrollY"
        :keyboard-config="{isArrow: true}"
        :column-config="{resizable: true}"
        :row-config="{isCurrent: true, isHover: true}"
        :loading="loading"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe
        style="margin-top: 2px"
        @checkbox-all="selectAllEvent"
        @checkbox-change="selectChangeEvent">
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column field="command.addTime" sortable title="business.label.addTime" width="170"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:operationTypes}" field="command.operationType" title="business.label.operationType" width="80"/>
        <vxe-column field="container.no" title="business.label.containerNo" width="90"/>
        <vxe-column field="sourceLocation.roadway" title="business.label.sourceRoadway" width="60"/>
        <vxe-column field="sourceLocation.no" title="business.label.sourceLocation" width="120"/>
        <vxe-column field="targetLocation.roadway" title="business.label.targetRoadway" width="80"/>
        <vxe-column field="targetLocation.no" title="business.label.targetLocation" width="120"/>
        <vxe-column field="workstation.name" title="business.label.workstation" width="100"/>
        <vxe-column field="command.orderOfPicking" title="business.label.priority" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:commandStatus}" field="command.commandStatus" title="business.label.commandStatus" width="100"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.activated" title="business.label.activated" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.checked" title="business.label.sent" width="70"/>
        <vxe-column field="command.wave" title="business.label.wave" width="100"/>
        <vxe-column field="command.id" title="business.label.commandId" width="180"/>
        <vxe-column field="command.errorMessage" title="business.label.errorMessage"/>
        <operate-column :dropdown-buttons="dropdownButtons" :fixed-buttons="fixedButtons"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <zone-modal ref="zoneModal" :title="'工作站检索'" @change="(rows)=>onWorkstationSelected(rows[0])"/>
    <inbound-scan ref="inboundScanModal" @success="refresh"/>
    <inbound-complete ref="inboundCompleteModal" @success="refresh"/>
    <seeding-position-bind ref="seedingPositionBindModal" @success="refresh"/>
  </vxe-layout-body>
</template>

<script>
import Vue from 'vue'
import Api from '@/api'
import { findAll, findEnum, post } from '@/api/Api'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import CompactForm from '@/views/admin/CompactForm.vue'
import OperateColumn from '@/views/admin/OperateColumn.vue'
import InboundScan from '@/views/operation/deive_monitor/modal/InboundScanModal.vue'
import InboundComplete from '@/views/operation/deive_monitor/modal/InboundCompleteModal.vue'
import SeedingPositionBind from '@/views/operation/deive_monitor/modal/SeedingPositionBindModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import { ContainerCommand } from '@/api/dto/command/ContainerCommand'
import { Zone } from '@/api/dto/common/Zone'

export default {
  name: 'DeviceMonitor',
  components: { CompactForm, OperateColumn, SeedingPositionBind, InboundComplete, InboundScan, ZoneModal },
  data() {
    return {
      loading: false,
      data: [],
      operationTypes: [],
      commandStatus: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: new ContainerCommand(),
      selectedRows: [],
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * 0.78,
      fixedButtons: [
        {
          content: 'button.inboundScan',
          show: (row) => row.command?.operationType === 1,
          click: (row) => this.scan(row)
        },
        {
          content: 'button.inboundComplete',
          show: (row) => row.command?.operationType === 1,
          click: (row) => this.putaway(row)
        },
        {
          content: 'button.outboundTaken',
          show: (row) => row.command?.operationType > 1,
          click: (row) => this.fetch(row)
        },
        {
          content: 'button.outboundComplete',
          show: (row) => row.command?.operationType > 1,
          click: (row) => this.arrive(row)
        }
      ],
      dropdownButtons: [
        {
          content: 'button.goBack',
          show: (row) => row.command?.operationType > 1,
          click: (row) => this.goback(row)
        },
        {
          content: 'button.increasePriority',
          show: (row) => row.command?.operationType > 1,
          click: (row) => this.promote(row)
        },
        {
          content: 'button.bindSeedingPosition',
          show: (row) => row.command?.operationType === 2,
          click: (row) => this.bindSeedingPosition(row)
        }
      ]
    }
  },
  computed: {
    queryItems() {
      return [
        {
          field: 'container.no',
          itemRender: {
            name: 'VxeInput',
            props: {
              placeholder: 'placeholder.containerNo',
              clearable: true
            }
          }
        },
        {
          field: 'operationType',
          itemRender: {
            name: 'VxeSelect',
            options: this.operationTypes,
            props: {
              placeholder: 'placeholder.operationType',
              clearable: true
            }
          }
        },
        {
          field: 'commandStatus',
          itemRender: {
            name: 'VxeSelect',
            options: this.commandStatus,
            props: {
              placeholder: 'placeholder.commandStatus',
              clearable: true
            }
          }
        },
        {
          field: 'workstation.no',
          itemRender: {
            name: 'VxeInput',
            props: {
              placeholder: 'business.label.workstation',
              clearable: true
            },
            events: {
              click: () => this.$refs.zoneModal.open({ 'workstation': true })
            }
          }
        },
        {
          field: 'error',
          itemRender: {
            name: 'VxeSelect',
            options: [
              { label: this.$t('business.label.true'), value: true },
              { label: this.$t('business.label.false'), value: false }
            ],
            props: {
              placeholder: 'business.label.error',
              clearable: true
            }
          }
        },
        {
          field: 'checked',
          itemRender: {
            name: 'VxeSelect',
            options: [
              { label: this.$t('business.label.true'), value: true },
              { label: this.$t('business.label.false'), value: false }
            ],
            props: {
              placeholder: 'button.sending',
              clearable: true
            }
          }
        }
      ]
    }
  },
  created() {
    findEnum('OperationType').then(res => {
      if (res.success) {
        this.operationTypes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    findEnum('CommandStatus').then(res => {
      if (res.success) {
        this.commandStatus = res.result.filter(item => item.ordinal === 0 || item.ordinal === 63 || item.ordinal === 64 || item.ordinal === 65 || item.ordinal === 66 || item.ordinal === 99).map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
  },
  methods: {
    selectAllEvent({ checked }) {
      this.selectedRows = this.$refs.table.getCheckboxRecords()
      //console.log(checked ? '所有勾选事件' : '所有取消事件', records)
    },
    selectChangeEvent({ checked }) {
      this.selectedRows = this.$refs.table.getCheckboxRecords()
      //console.log(checked ? '勾选事件' : '取消事件', records)
    },
    onWorkstationSelected(workstation) {
      this.query.workstation = new Zone(workstation)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    refresh() {
      this.loading = true
      const args = {
        'container.no': this.query.container.no,
        operationType: this.query.operationType,
        commandStatus: this.query.commandStatus,
        'zone.no': this.query.workstation.no,
        error: this.query.error,
        checked: this.query.checked,
        wave: this.query.wave
      }
      findAll('automationMonitorFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    scan(row) {
      this.$refs.inboundScanModal.open(row)
    },
    putaway(row) {
      this.$refs.inboundCompleteModal.open(row)
    },
    fetch(row) {
      let args = { 'command.id': row.command.id }
      post(Api.containerFetch, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.successTip('出库索取成功')
        }
      }).finally(() => this.loading = false)
    },
    arrive(row) {
      let args = { 'container.no': row.container.no }
      post(Api.containerArrive, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.successTip('出库已完成')
        }
      }).finally(() => this.loading = false)
    },
    goback(row) {
      let args = { 'container.no': row.container.no }
      post(Api.containerGoback, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.successTip('回库成功')
        }
      }).finally(() => this.loading = false)
    },
    promote(row) {
      let args = { 'id': row.command.id }
      post(Api.commandPromote, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.successTip('提升优先级成功')
        }
      }).finally(() => this.loading = false)
    },
    bindSeedingPosition(row) {
      this.$refs.seedingPositionBindModal.open(row)
    },
    successTip(message) {
      let that = this
      that.$success({
        title: message,
        onOk() {
          that.refresh()
        },
        okText: '确定',
        centered: true
      })
    },
    send() {
      const args = {
        wave: this.query.wave,
        ids: this.selectedRows.map(row => row.command.id)
      }
      post(Api.containerSend, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.successTip('发送成功')
        }
      }).finally(() => this.loading = false)
    },
    reset() {
      this.query = new ContainerCommand()
      this.data = []
    }
  }
}
</script>